import { getAssetPath } from '@stencil/core';
import state from '../store/settings';
import { IGame } from '../interfaces/game';

export function thousandsSeparator(number: number | string): string {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function formatLargeNumber(number: number | string): string {
  if (typeof number === 'string') {
    number = number.replace(/([RN])/, '');
  }
  let num = Number(number);
  let stringNum = number.toString();

  const ranges = [
    { divider: 1e18, suffix: 'Q' },
    { divider: 1e15, suffix: 'Q' },
    { divider: 1e12, suffix: 'T' },
    { divider: 1e9, suffix: 'B' },
    { divider: 1e6, suffix: 'M' },
    { divider: 1e4, suffix: 'K' },
    { divider: 1e3, suffix: 'K' },
  ];

  for (const range of ranges) {
    if (num >= range.divider) {
      stringNum = range.suffix === 'K' ? (num / 1000).toString().replace('.', ',') : (num / range.divider).toString().replace('.', ',');
      stringNum = stringNum.slice(0, stringNum.indexOf(','));
      stringNum = stringNum + range.suffix;
      break;
    }
  }

  return stringNum;
}

export async function setFonts() {
  const hasRoboto = document.fonts.check('16px Roboto');
  if (!hasRoboto) {
    const robotoPath = getAssetPath('../../assets/Roboto.woff');
    const robotoObj = new FontFace('Roboto', `url(${robotoPath})`, {
      weight: '400',
      style: 'normal',
      display: 'swap',
      unicodeRange: 'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD',
    });
    const robotoLoaded = await robotoObj.load();
    (document.fonts as any).add(robotoLoaded);
  }

  const hasInterface = document.fonts.check('16px Interface');
  if (!hasInterface) {
    const interfacePath = getAssetPath('../../assets/Interface-700.woff');
    const interfaceObj = new FontFace('Interface', `url(${interfacePath})`, {
      weight: '700',
      style: 'normal',
      display: 'swap',
    });
    const interfaceLoaded = await interfaceObj.load();
    (document.fonts as any).add(interfaceLoaded);
  }
}

export function getRequestUrl({ path, queryParams, useCdn }: { path: string; queryParams: {}; useCdn?: boolean }): string {
  const query = serializeQueryString({ params: queryParams });
  if (useCdn) return `${state.apiCdnPath}/${path}/${query ? '?' + query : ''}`;
  return `${state.apiBasePath}/${path}/${query ? '?' + query : ''}`;
}

export function getStoredFavourites(): IGame[] {
  try {
    const favourites = JSON.parse(sessionStorage.getItem('favourite-games'));
    return favourites ? favourites : null;
  } catch (err) {
    return null;
  }
}

export function setFavouriteGames(games: IGame[]) {
  sessionStorage.setItem('favourite-games', JSON.stringify(games));
}

export function getUserId() {
  const userInfo = parseJwt(state.token);
  let userId: string = null;

  for (const key in userInfo) {
    if (key.includes('nameidentifier')) {
      userId = userInfo[key];
    }
  }

  return userId;
}

function parseJwt(token: string) {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (e) {
    return null;
  }
}

function serializeQueryString(obj: { params: {} }): string {
  const str = [];
  const { params } = obj;
  if (!params) return '';
  for (const p in params)
    if (Object.prototype.hasOwnProperty.call(params, p)) {
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(String(params[p])));
    }
  return str.join('&');
}
